
import { reactive} from "vue";
import DynamicForm from "@/components/Shared/Dynamicform/DynamicForm.vue";

export default {
  name: "FischbuchEintragLinthkanal",
  inheritAttrs: false,
  components: {
    DynamicForm
  },
    setup() {
      const request = reactive({
        apiLoadMethod: "api/Form/loadForm",
        apiSaveMethod: "api/sync/syncFishbook",
        form: "FischbuchEintragLinthkanal",
        page: "FischbuchEintragLinthkanalDaten",
        remoteId: "",       
        routeName: "",
        filter: ""
      });
      return {
        request
      };
    }
  };
  